import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Edit from '@material-ui/icons/Edit'
import moment from "moment";

export default class Customers extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Customers._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Name",
				id: "name",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.name)
			},
			{
				Header: "Phone",
				className: 'center-column',
				accessor: "phone",
			},
			{
				Header: "Email",
				accessor: "email",
			},
			{
				Header: "DOB",
				className: 'center-column',
				id: 'birth_date',
				accessor: obj => obj.birth_date ? moment(obj.birth_date).local()
					.format("MM/DD/YYYY") : 'N/A',

			},
			{
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				/** @param {Customers_Object} obj */
				accessor: obj => obj.name,
				Cell: props => {
					return (
						<span data-cy={`edit-${props.original.name}`}>
							<Link to={"/customers/" + props.original.pkey}>
								<Button color="green-meadow" size={"sm"} block={true} style={{ marginTop: '6px' }}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Customers')}
							{this.renderHeaderRight("Customers",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
